import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { vendorOptions } from '@app/shared/constants/constants';
import {
  JobDetErrorMsg,
  VendorsDropdownOptions,
} from '@app/shared/constants/global.enum';
import { ToasterService } from '@app/shared/services/toaster.service';
import { TimesheetEnum } from '@constants/global.enum';

@Component({
  selector: 'app-ops-vendor-management',
  templateUrl: './ops-vendor-management.component.html',
  styleUrls: ['./ops-vendor-management.component.scss'],
})
export class OpsVendorManagementComponent {
  isModalOpen = false;
  timesheet = TimesheetEnum.TimeSheet;
  openForm = false;
  selectedAction: string | null = null;
  vendorOptions = vendorOptions;
  VendorsDropdownOptions = VendorsDropdownOptions;
  JobDetErrorMsg = JobDetErrorMsg
  showMsaExpiry = false;

  constructor(private router: Router,private toasterService: ToasterService,) {}

  toggleModal(): void {
    this.isModalOpen = !this.isModalOpen;
  }

  navigateToQuarterlyFeedback(): void {
    this.router.navigate(['/ops-vendor-management/quarterly-feedback']);
  }

  navigateToTimesheet(): void {
    this.router.navigate(['/ops-vendor-management/timesheet']);
  }

  handleOptionClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    const basePath = '/ops-vendor-management';
    if (target.tagName === 'LI') {
      const option = target.innerText.trim();
      this.isModalOpen = false;
      switch (option) {
        case 'Invite vendor':
          this.selectedAction = 'invite-vendor';
          this.openForm = true;
          break;
        case 'Onboard Vendor':
        case 'Show All Vendors':
        case 'Admin Screen':
          const subPath = VendorsDropdownOptions[option];
          if (subPath) {
            this.router.navigate([basePath, subPath]);
          }
          break;
        case 'User Activity':
          this.router.navigate(['/adoption']);
          break;
        default:
          this.toasterService.showError(JobDetErrorMsg.errorVendorMessage, 'Error');
          break;
      }
    }
  }
  onInviteFormClose(): void {
    this.openForm = false;
    this.selectedAction = null;
  }
}
